<div *ngIf="errorMessage?.length" class="alert alert-danger">{{errorMessage}}</div>
<div *ngIf="chooseNewNumber">
    <r247-number-chooser
        reserveNumberCaption="Purchase Number"
        chooseNumberCaption="Please Choose Another Number"
        numberChosenCaption="Your new Number"
        (numberConfirmed)="purchaseNewNumber($event)"
    ></r247-number-chooser>
</div>